import axios from '../config/axiosConfig';

const API_URL = '/repeater-tabs';

const getAll = async (params = {}) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

const getClosed = async (params = {}) => {
  const response = await axios.get(`${API_URL}/closed`, { params });
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

const create = async (data) => {
  const response = await axios.post(API_URL, data);
  return response.data;
};

const update = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}`, data);
  return response.data;
};

const close = async (id) => {
  const response = await axios.put(`${API_URL}/${id}/close`);
  return response.data;
};

const reopen = async (id) => {
  const response = await axios.put(`${API_URL}/${id}/reopen`);
  return response.data;
};

const reorder = async (tabIds) => {
  const response = await axios.post(`${API_URL}/reorder`, { tabIds });
  return response.data;
};

const bulkClose = async (data) => {
  const response = await axios.post(`${API_URL}/bulk-close`, data);
  return response.data;
};

const remove = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

const repeaterTabService = {
  getAll,
  getClosed,
  getById,
  create,
  update,
  close,
  reopen,
  reorder,
  bulkClose,
  remove
};

export default repeaterTabService;
